import Loadable from 'react-loadable';

import PleaseWait from '~/components/loaders/please-wait';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "novo-nordisk", webpackPrefetch: true */ './Novo-nordisk'),
  loading: () => <PleaseWait />,
});
